import { emptys } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { updateRowData } from "../../../store/updateData";
import { getCurrentDate } from "../../../utils/getCurrentDate";
import { getItemType } from "../../../utils/getItemType";
import { startAction } from "./startAction";

const checkBatches = (items: stdObject[], itemType: string) => {
  let batchesLine = 0;
  items.forEach((e: stdObject, index: number) => {
    if (
      batchesLine === 0 &&
      "BATCHES" in e &&
      e.BATCHES.reduce(
        (acc: number, curr: stdObject) => (acc += curr.CANBA0),
        0,
      ) > e[`CAN${itemType}`]
    ) {
      batchesLine = index;
    }
  });
  return batchesLine;
};

export const startSaveDocument = async ({
  t,
  user,
  items,
  userAccess,
  dispatch,
  documentAction,
  setMsg,
  setMsg2,
  docValues,
  setStationeryModal,
  openModal,
  setWindowValues,
  setDocValues,
  setModalData,
  openInnerSelection,
  setModalData2,
  closeMsg,
  closeMsgDoc,
  guarantees,
  logoutAction,
}: stdObject) => {
  const invalidBatchLine = checkBatches(docValues.items, docValues.itemType);
  if (invalidBatchLine > 0) {
    setMsg2("custom2");
    setModalData2({
      code: "warning",
      title: t(`p.batchErrorOnLine`, { line: invalidBatchLine }),
      buttons: [
        {
          label: t("p.close"),
          onClick: () => closeMsg(2),
        },
      ],
    });
    return false;
  }
  setMsg("loading");
  let tempSaveDocData = { ...docValues };
  tempSaveDocData.data = Object.keys(tempSaveDocData.data).reduce(
    (acc: stdObject, curr: string) => {
      acc[curr] = tempSaveDocData.data[curr].value;
      return acc;
    },
    {},
  );

  if (tempSaveDocData.data[`COD${docValues.type}`] === 0) {
    tempSaveDocData.data[`FEC${docValues.type}`] = getCurrentDate(true);
    if (
      `ALM${docValues.type}` in tempSaveDocData.data &&
      emptys.includes(tempSaveDocData.data[`ALM${docValues.type}`])
    ) {
      tempSaveDocData.data[`ALM${docValues.type}`] = docValues.serie;
    }
  }

  tempSaveDocData.staff = Object.keys(tempSaveDocData.staff).reduce(
    (acc: stdObject, curr: string) => {
      acc[curr] = {
        id: tempSaveDocData.staff[curr].value,
        name: tempSaveDocData.staff[curr].name,
      };
      return acc;
    },
    {},
  );

  if (docValues.type === "SEV") {
    tempSaveDocData.tecnic = user.TEC;

    if (user.TEC === 4) {
      delete tempSaveDocData.data.PAGSEV;
    }
  }

  const isOnlyIssues =
    docValues.type === "SEV" &&
    [3, 5].includes(user.TEC) &&
    tempSaveDocData.data[`COD${docValues.type}`] > 0;

  if (isOnlyIssues) {
    tempSaveDocData = {
      serie: tempSaveDocData.serie,
      code: tempSaveDocData.data[`COD${docValues.type}`],
      status: tempSaveDocData.data[`PAG${docValues.type}`],
      issues: tempSaveDocData.issues,
    };
  }

  if (docValues.type === "TRA") {
    tempSaveDocData.serie2 = tempSaveDocData.data[`ALM2${docValues.type}`];
    tempSaveDocData.automaticTransfer =
      !tempSaveDocData.isTransferIn && user.TRAROL;
  }

  if ("batches" in docValues) {
    Object.keys(docValues.batches).forEach((e: string) => {
      docValues.batches[e] = docValues.batches[e].map((v: stdObject) =>
        "data" in v ? { ...v.data, ARTBA0: v.ARTBA0, LINBA0: v.LINBA0 } : v,
      );
    });
  }

  console.log("tempSaveDocData", tempSaveDocData);
  const responseSaveDocument: stdObject = await sendData({
    endPoint: isOnlyIssues ? "saveOnlyIssues" : "saveDocument",
    payload: tempSaveDocData,
    logoutAction,
  });

  console.log("responseSaveDocument", responseSaveDocument);
  if (responseSaveDocument.success && responseSaveDocument.status) {
    dispatch(
      updateRowData({
        type: responseSaveDocument.type,
        data: [responseSaveDocument.data],
      }),
    );

    if (documentAction.current.action) {
      startAction(
        {
          code: responseSaveDocument.data[`COD${responseSaveDocument.type}`],
          start: true,
          docSndValues:
            documentAction.current.action === "transfer"
              ? {
                  type: responseSaveDocument.type,
                  itemType: getItemType(responseSaveDocument.type),
                  serie:
                    responseSaveDocument.data[
                      `SER${responseSaveDocument.type}`
                    ],
                  code: responseSaveDocument.data[
                    `COD${responseSaveDocument.type}`
                  ],
                }
              : docValues,
        },
        {
          t,
          user,
          items,
          userAccess,
          docValues,
          documentAction,
          setDocValues,
          setStationeryModal,
          openModal,
          setMsg,
          setMsg2,
          setModalData,
          setModalData2,
          closeMsg,
          openInnerSelection,
          setWindowValues,
          guarantees,
          logoutAction,
        },
      );
      setDocValues({ ...docValues, updated: false });
    } else {
      closeMsgDoc(true);
      setWindowValues({});
      closeMsg();
    }
  } else {
    console.log("existingBatches", responseSaveDocument.existingBatches);
    const { existingBatches, error } = responseSaveDocument;
    setMsg2("custom2");

    if (existingBatches) {
      const batItem = existingBatches.ARTBAT ?? existingBatches.ARTBA0;
      const batId = existingBatches.IDBAT ?? existingBatches.IDBA0;

      const docParts = existingBatches.INIBAT
        ? existingBatches.INIBAT.split(".")
            .map((e: string, index: number) => (index ? e : t(`c.${e}`)))
            .join(" ")
        : t("p.line") + " " + existingBatches.LINBA0;

      setModalData2({
        code: "warning",
        title: t(`p.${error}`),
        label: `${batItem} [${batId}]: ${docParts}`,
        buttons: [
          {
            label: t("p.close"),
            onClick: () => closeMsg(2),
          },
        ],
      });
    } else {
      setModalData2({
        code: "warning",
        title: t(`p.${error}`),
        buttons: [
          {
            label: t("p.close"),
            onClick: () => closeMsg(2),
          },
        ],
      });
    }
    closeMsg();
  }
};
